import React, {memo, useCallback} from 'react';
import {useNavigate} from 'react-router-dom';

import {SecondaryTabs, Tab} from '@pb/kit-component-tabs-v2';

import {MCP_TABS} from '../constants';

import {mcpFrame, mcpTabs} from './tabs-structure.module.styl';

type Props = {
    accountId: number,
    activeTab: string,
    children: React.ReactElement,
};

export const TabsStructure = memo<Props>(({accountId, children, activeTab}) => {
    const navigate = useNavigate();

    const onTabChange = useCallback((tab: string) => {
        navigate(`/profile/account/${accountId}/mcp/${tab}`);
    }, [accountId, navigate]);

    return (
        <div className={mcpFrame}>
            <SecondaryTabs className={mcpTabs} value={activeTab} onChange={onTabChange} style={{width: '100%'}}>
                <Tab key={MCP_TABS.SETUP.name} value={MCP_TABS.SETUP.name} {...MCP_TABS.SETUP}/>
                <Tab key={MCP_TABS.PRICING.name} value={MCP_TABS.PRICING.name} {...MCP_TABS.PRICING}/>
                <Tab key={MCP_TABS.ALERTS.name} value={MCP_TABS.ALERTS.name} {...MCP_TABS.ALERTS}/>
            </SecondaryTabs>
            {children}
        </div>
    );
});
